import packageInfo from '../../package.json';
import preval from 'preval.macro';

export const VERSION = packageInfo.version;
export const BUILD_TIMESTAMP = preval`module.exports = new Date().toUTCString();`;

export default {
  VERSION,
  BUILD_TIMESTAMP,
};
